import React from 'react';
import SectionCard from '../../common/sectionCard/SectionCard';
import styles from '../styles/team.module.scss';
import RolePermissionsCardItem from './RolePermissionsCardItem';

/**
 * Reads this FI's own role catalog (fetched from GET /api/roles/:aba, the
 * same source the Role Composer uses) — nothing here is a hardcoded list of
 * role names or descriptions, since an FI can rename/create/delete its
 * roles freely from the Role Composer.
 */
function RolePermissionsCard({ roles = [] }) {
    const items = roles.map((role) => {
        const scopeCount = role.scope_keys?.length || 0;
        const scope = role.is_owner_role
            ? 'Full Access'
            : scopeCount === 0
                ? 'No Access'
                : `${scopeCount} scope${scopeCount === 1 ? '' : 's'}`;
        const description = role.description
            || (scopeCount === 0
                ? 'No scopes assigned yet — this role currently sees an empty navigation.'
                : `Assigned ${scopeCount} scope${scopeCount === 1 ? '' : 's'}. Configure this role in the Role Composer.`);

        return { id: role.id, role: role.name, scope, description };
    });

    return (
        <SectionCard title="Role Permissions">
            <div className={styles.permissionsList}>
                {items.map((item) => (
                    <RolePermissionsCardItem
                        key={item.id}
                        role={item.role}
                        scope={item.scope}
                        description={item.description}
                    />
                ))}
            </div>
        </SectionCard>
    );
}

export default RolePermissionsCard;
